import React, { useMemo } from 'react'
import { usePreviewAsset } from '../../store'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { Asset, queryAsset } from '../../api/backend'
import { TopBodyLayout } from '../../components/top-body-layout'
import { Contact } from '../../components/connected-contact'
import { PdfViewer } from '../../components/pdf-viewer'
import styled from 'styled-components'
import { useChangeTitle, useTrackView } from '../../hooks'
import { OfficeViewer } from '../../components/office-viewer'
import { Empty, Loading } from 'antd-mobile'

export const useAsset = (): [Asset | undefined, boolean] => {
  const params = useParams<{ assetId: string }>()
  const assetId = parseInt(params.assetId, 10)
  const previewAsset = usePreviewAsset()
  const { data, isLoading } = useQuery({
    queryKey: ['asset', assetId],
    queryFn: () => queryAsset(assetId),
    enabled: !previewAsset && !isNaN(assetId),
    staleTime: Number.POSITIVE_INFINITY, // refetching this query increments server's asset view count, so best to not refetch at all
  })
  return [previewAsset ?? data, isLoading]
}

const ViewerContainer = styled.div`
  flex: auto;
  min-height: 50%;
  width: 100%;
`

export const Preview: React.FC<{ miniProgram: boolean }> = ({ miniProgram }) => {
  const [asset, loading] = useAsset()
  useChangeTitle(asset)
  const trackView = useTrackView()
  const viewer = useMemo(() => {
    if (!asset?.resource) {
      return <Empty />
    }
    const { assertId, resource: { type, src } } = asset
    switch (type) {
      case 5:
        return <PdfViewer src={src} onLoad={() => trackView(assertId)} />
      case 4:
      case 6:
      case 8:
        return <OfficeViewer src={src} onLoad={() => trackView(assertId)} />
      default:
        return null
    }
  }, [asset, trackView])
  const content = loading
    ? <Loading />
    : (
      <ViewerContainer>
        {viewer}
      </ViewerContainer>
    )
  return miniProgram
    ? content
    : (
      <TopBodyLayout top={<Contact />} bodyScrollable={false}>
        {content}
      </TopBodyLayout>
    )
}
